(function() {
  'use strict';
  angular.module('dnSecurity')
  .directive('secAuthorized',['secSecurityService', '$q', '$rootScope', '$animate', '$compile',
  function(securityService, $q, $rootScope, $animate, $compile) {
    var directiveDefinitionObject = {
      restrict: 'A',
      transclude: 'element',
      scope: {
        allAuthorities: '@',
        anyAuthorities: '@',
        noAuthorities: '@'
      },
      priority: 600,
      link: function($scope, element, attrs, ctrl, $transclude) {
        function watch(values) {
          let allAuthorities, anyAuthorities, noAuthorities;
          [allAuthorities, anyAuthorities, noAuthorities] = _.map(values, (val) => val && _.split(val,',') || []);
          $q.all([securityService.hasAllAuthorities(allAuthorities),
            securityService.hasAnyAuthority(anyAuthorities),
            securityService.notGrantedAuthorities(noAuthorities),
            securityService.getAuthorities()]
          )
          .then((values) => {
            $scope.authorized = values[0] && values[1] && values[2] && values[3].length;
          });
        }
        $rootScope.$on('authenticationChanged', function() {
          watch([$scope.allAuthorities, $scope.anyAuthorities, $scope.noAuthorities]);
        });
        $scope.$watchCollection('[allAuthorities, anyAuthorities, noAuthorities]', watch);
        let block, childScope, previousElements;
        $scope.$watch('authorized', function(authorized) {
          if(authorized) {
            if (!childScope) {
              $transclude(function(clone, newScope) {
                childScope = newScope;
                clone[clone.length++] = $compile.$$createComment('end authorized', attrs.anyAuthorities);
                // Note: We only need the first/last node of the cloned nodes.
                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
                // by a directive with templateUrl when its template arrives.
                block = {
                  clone: clone
                };
                $animate.enter(clone, element.parent(), element);
              });
            }
          } else {
            if(previousElements) {
              previousElements.remove();
              previousElements = null;
            }
            if(childScope) {
              childScope.$destroy();
              childScope = null;
            }
            if(block) {
               previousElements = block.clone;
               previousElements.remove();
               previousElements = null;
               block = null;
            }
          }
        });
      }
    };
    return directiveDefinitionObject;
  }]);
})();
